"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.eventCategories = void 0;
var eventCategories = {
  ACTIVITY: "activity",
  BLUE_DISTINCTION: "blueDistinction",
  CARDS: "cards",
  CARE: "getCare",
  CHAT: "chat",
  CLAIMS: "claims",
  COST: "costTransparency",
  DOCUMENTS: "documents",
  FOOTER: "footer",
  FUNDS: "funds",
  HELP: "helpCenter",
  HOME: "home",
  HOW_WE_HELP: "howWeHelp",
  INBOX: "inbox",
  LOGIN: "login",
  MSOON: "msoon",
  NAV: "nav",
  NEW_USER_REGISTRATION: "newUserRegistration",
  PARTNERS: "partners",
  PEOPLE: "people",
  PERSONALIZATION: "personalization",
  PLANS: "plans",
  PROOF_OF_COVERAGE: "proofOfCoverage",
  REGISTRATION: "registration",
  SESSION: "session",
  SETTINGS: "settings"
};
exports.eventCategories = eventCategories;